import { classes } from "portal/theme/theme";
import { Dimensions } from "portal/utils/categoryCollection/image";
import { IconOverlay } from "./IconOverlay";
import AddIcon from "@mui/icons-material/Add";
import React, { FC } from "react";
import RemoveIcon from "@mui/icons-material/Remove";

interface DiffOverlayProps {
  dimensions: Dimensions;
  change: "added" | "removed";
}
export const DiffOverlay: FC<DiffOverlayProps> = ({ dimensions, change }) => {
  return (
    <>
      <div
        className={classes(
          "absolute top-0 left-0 border-solid pointer-events-none",
          {
            "border-green-200 bg-[image:radial-gradient(circle_at_center,transparent_0%,transparent_40%,theme(colors.green.600/85%)_100%)]":
              change === "added",
            "bg-black/45 border-red-500 bg-[image:repeating-linear-gradient(-45deg,theme(colors.black/45%)_0,theme(colors.black/45%)_4px,transparent_4px,transparent_8px)]":
              change === "removed",
          }
        )}
        style={{ ...dimensions }}
      >
        <div className={classes("flex flex-col h-full")}>
          <div className="flex justify-between w-full gap-1"></div>
        </div>
      </div>
      <IconOverlay
        position="top-right"
        icon={
          change === "added" ? (
            <AddIcon className="text-green-200" />
          ) : (
            <RemoveIcon className="text-red-500" />
          )
        }
      />
    </>
  );
};
